// extracted by css-extract-rspack-plugin
export default {"footer":"Footer-module__footer__rWx13","spacer":"Footer-module__spacer__yLr5_","footerItem":"Footer-module__footerItem__H6aUw"};